export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7922.0431f6eb.jpg";